var _path, _path2, _path3, _circle;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgStarters = function SvgStarters(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.262 6.49 3.833 16.917",
    stroke: "#1B2230",
    strokeWidth: 0.643
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.426 7.834c-.23.23-.505.407-.811.525a2.465 2.465 0 0 1-.974.159 2.681 2.681 0 0 1-.989-.232 2.838 2.838 0 0 1-1.438-1.439 2.683 2.683 0 0 1-.232-.988 2.465 2.465 0 0 1 .159-.974c.117-.306.296-.582.525-.811l1.88 1.88 1.88 1.88Z",
    fill: "#FF5454"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B2230",
    d: "m10.417 7.125 3.209 3.209-3.209 3.209-3.209-3.21z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.613,
    cy: 14.138,
    r: 1.702,
    transform: "rotate(-45 6.613 14.138)",
    fill: "#94A3B8"
  })));
};
export default SvgStarters;